import { createReducer, on } from '@ngrx/store';
import { InhibitionConnectivityActions } from './inhibition-connectivity.actions';
import { tableState } from '../common/types/table/table-state.type';
import { INITIAL_TABLE_STATE } from '../common/constants/table/table-state.constants';

export const inhibitionConnectivityFeatureKey = 'InhibitionConnectivity';

export const inhibitionConnectivityReducer = createReducer<tableState>(
    INITIAL_TABLE_STATE,
    on(
        InhibitionConnectivityActions.fetchSuccess,
        (_, { data }): tableState => ({
            loading: false,
            hasError: false,
            data: data
        })
    ),
    on(InhibitionConnectivityActions.searchAll,
        (): tableState => ({
            loading: true,
        })
    ),
    on(InhibitionConnectivityActions.fetchFailure,
        (_, {message}): tableState => ({
            loading: false,
            hasError: true,
            errorMessage: message
        })
    )
);
